import React from "react"
import { isEmpty } from "lodash"
import "./_style.scss"

import { GatsbyImage } from "gatsby-plugin-image"

// Swiper
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"

// Atoms
import RulerTitle from "§/src/components/atoms/title/ruler-title"
import ButtonEdgeRounded from "§/src/components/atoms/buttons/button-edge-rounded"
import TileContentProduct from "§/src/components/atoms/content/tile-content-product"
import Modal from "§/src/components/atoms/content/modal"

// Assets
import ArrowIcon from "§/src/images/svg/arrow-r.svg"

// Language
import { useTranslation } from "react-i18next"

const Related = props => {
  const { t } = useTranslation()
  const slider = props.data

  // set component class
  const compClassName = "pb-5"
  var compClass =
    props.className != undefined
      ? compClassName + " " + props.className
      : compClassName

  const sliderId = "prod-" + Math.floor(Math.random() * 9999)

  return !isEmpty(slider) ? (
    <React.Fragment>
      <div comp="related-products" className={compClass}>
        <RulerTitle
          ctaUrl="#"
          pretitle={t("Altri prodotti")}
          title={t("Ti potrebbe interessare")}
          // ctaText={slider?.length >= 5 ? t("Vedi tutti") : false}
          ctaText={false}
        />

        <Swiper
          // autoplay={{
          // 	delay: 5000,
          // 	disableOnInteraction: true,
          // }}
          slidesPerView={1.5}
          spaceBetween={0}
          loop={slider?.length < 5 ? false : true}
          watchOverflow={true}
          breakpoints={{
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
          pagination={{
            el: "#" + sliderId + "-pagination",
            type: "progressbar",
          }}
          navigation={{
            nextEl: "#" + sliderId + "-nav-next",
            prevEl: "#" + sliderId + "-nav-prev",
          }}
          modules={[Pagination, Navigation]}
          className="products-swiper"
          id={sliderId}
        >
          {slider
            .filter(productTile => productTile.acf.badge !== "phase_out" && productTile.acf.badge !== "eop")
            .map((productTile, pageIndex) => {
            return (
              <SwiperSlide key={pageIndex}>
                <TileContentProduct configModalId="relatedProdConfigModal" data={productTile} className="" />
              </SwiperSlide>
            )
          })}

          <div className="sw-navigation">
            <ButtonEdgeRounded
              id={sliderId + "-nav-prev"}
              dir="start"
            ></ButtonEdgeRounded>
            <ButtonEdgeRounded
              id={sliderId + "-nav-next"}
              dir="end"
            ></ButtonEdgeRounded>
          </div>
        </Swiper>

        <div
          id={sliderId + "-pagination"}
          className="gefran-swiper-pagination-progressbar position-relative mt-4 mt-md-5"
        ></div>

        <button type="button" className="btn text-wrap view-all d-none">
          <span>{t("Vedi tutti")}</span>
          <ArrowIcon></ArrowIcon>
        </button>
      </div>

      <Modal modalid="relatedProdConfigModal">
        <div className="ratio ratio-16x9 text-center mt-4 mb-4">
          <iframe
            data-src=""
            className="embed-responsive-item"
          ></iframe>
        </div>
      </Modal>
    </React.Fragment>
  ) : (
    ""
  )
}

export default Related
